// extracted by mini-css-extract-plugin
export default {"container":"Bt-z","title":"Ct-z","linkContainer":"Dt-z","viewItemLink":"Et-z"};